import { createEdgeSpark } from "@edgespark/client";
import "@edgespark/client/styles.css";

export const client = createEdgeSpark({
  baseUrl: "https://staging--odmogakqpkdt4p1v70ne.youbase.cloud"
});
